export default {
  logout: '/auth/logout',
  updateTTL: '/auth/update/primary/ttl',
  loginWithSut: '/auth/single-use-token',
};
